export const initPolyFill = () => {
	// ES2020
	if (!Promise.allSettled) {
		import('core-js/es/promise/all-settled');
	}

	// ES2019
	if (!Array.prototype.flat) {
		import('core-js/es/array/flat');
	}
	// ES2019
	if (!Array.prototype.flatMap) {
		import('core-js/es/array/flat-map');
	}
	// ES2022
	if (!Array.prototype.at) {
		import('core-js/es/array/at');
	}
	// ES2023
	if (!Array.prototype.findLastIndex) {
		import('core-js/es/array/find-last-index');
	}
	// ES2023
	if (!Array.prototype.findLast) {
		import('core-js/es/array/find-last');
	}
	// ES2016
	if (!Array.prototype.includes) {
		import('core-js/es/array/includes');
	}

	// ES2021
	if (!String.prototype.replaceAll) {
		import('core-js/es/string/replace-all');
	}
	// ES2017
	if (!String.prototype.padStart) {
		import('core-js/es/string/pad-start');
	}
	// ES2017
	if (!String.prototype.padEnd) {
		import('core-js/es/string/pad-end');
	}

	// ES2017
	if (!Object.values) {
		import('core-js/es/object/values');
	}
	// ES2017
	if (!Object.entries) {
		import('core-js/es/object/entries');
	}
	// ES2019
	if (!Object.fromEntries) {
		import('core-js/es/object/from-entries');
	}
};
